import { render, staticRenderFns } from "./editorAgent.vue?vue&type=template&id=64b36706&scoped=true"
import script from "./editorAgent.vue?vue&type=script&lang=js"
export * from "./editorAgent.vue?vue&type=script&lang=js"
import style0 from "./editorAgent.vue?vue&type=style&index=0&id=64b36706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b36706",
  null
  
)

export default component.exports